import Vue from 'vue'
import Vuetify, { colors } from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // ↓あとで整理する
        primary: '#004e88',
        error: '#cd4444',
        commonModal: `${colors.blue.darken3}`,
        bar_border_1: '#a0c889',
        bar_bg_1: '#d8f2d6',
        app_bg: '#f6f6f6',
        table_header: '#97c6ea',
        footer_body: '#f9fbfe',
        baseText: '#ffffff',
        baseText_2: '#666666',
        baseText_3: '#333333',
        linkText: '#004e88',
        thinText: '#6a6a6a'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})
